import React from "react";
import { useParams } from "react-router-dom";
import { useRadarConfiguration } from "../../hooks/UseRadarConfiguration";
import { dataConfigTransform } from "../../contentful/transformers/config/config";
import { dataRadarTransform } from "../../contentful/transformers/radar/radar";
import Badge from "../Badge/Badge";
import ItemList from "../ItemList/ItemList";
import Link from "../Link/Link";
import FooterEnd from "../FooterEnd/FooterEnd";
import SetTitle from "../SetTitle";
import ItemRevisions from "../ItemRevisions/ItemRevisions";
import "./item-page.scss";
import { translate } from "../../config";
import { groupByQuadrants, Item } from "../../model";
import { useMessages } from "../../context/MessagesContext";

// update this function to GET PAGENAME/Quadrant Name FROM URL
const getItem = (quadrantName: string, itemName: string, items: Item[]) => {
  return items.filter(
    (item) => item.quadrant === quadrantName && item.name === itemName
  )[0];
};

const getItemsInRing = (
  quadrantName: string,
  itemName: string,
  items: Item[]
) => {
  const item = getItem(quadrantName || "", itemName || "", items);
  return groupByQuadrants(items)[item.quadrant][item.ring];
};

const PageItem: React.FC = () => {
  const { pageItem } = useMessages();
  const { radarName, quadrantName, itemName } = useParams();
  const { data: radarData } = useRadarConfiguration(radarName);

  const items = radarData && dataRadarTransform(radarData).items;
  const config = radarData && dataConfigTransform(radarData);
  const quadrantOverview = pageItem?.quadrantOverview || "Quadrant Overview";

  const itemsInRing = getItemsInRing(quadrantName || "", itemName || "", items || []);

  const item = getItem(quadrantName || " ", itemName || "", items || []);

  return (
    <>
      {config && items && (
        <>
          <SetTitle title={item.title} />
          <div className="item-page">
            <div className="item-page__nav">
              <div className="item-page__nav__inner">
                <div className="item-page__header">
                  <h3 className="headline">
                    {translate(config, item.quadrant)}
                  </h3>
                </div>
                <ItemList items={itemsInRing} activeItem={item}>
                  <div className="split">
                    <div className="split__left">
                      <Badge big type={item.ring}>
                        {item.ring}
                      </Badge>
                    </div>
                    <div className="split__right">
                      <Link
                        className="icon-link"
                        pageName={`/${radarName}/${item.quadrant}`}
                      >
                        <span className="icon icon--pie icon-link__icon" />
                        {quadrantOverview}
                      </Link>
                    </div>
                  </div>
                </ItemList>

                <div className="item-page__footer">
                  <FooterEnd modifier="in-sidebar" />
                </div>
              </div>
            </div>
            <div className="item-page__content">
              <div className="item-page__content__inner">
                <div className="item-page__header">
                  <div className="split">
                    <div className="split__left hero-headline__wrapper">
                      <h1 className="hero-headline hero-headline--inverse">
                        {item.title}
                      </h1>
                    </div>
                    <div className="split__right">
                      <Badge big type={item.ring}>
                        {item.ring}
                      </Badge>
                    </div>
                  </div>
                </div>
                <div
                  className="markdown"
                  dangerouslySetInnerHTML={{ __html: item.body }}
                />
                {item.revisions.length > 1 && (
                  <ItemRevisions
                    revisions={item.revisions.slice(1)}
                    dateFormat={config.dateFormat}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PageItem;
